module.exports = __webpack_public_path__ + "img/s1.3150893e.jpg";